import { createMuiTheme } from '@material-ui/core/styles';

/**
 * MUI theme for the app's custom-icon checkboxes.
 *
 * Two things matter here. It remaps `secondary` off MUI's default pink (#f50057), which
 * would otherwise tint the focus ripple and checked hover of any checkbox that does not
 * pass `color='default'`. And the MuiCheckbox override backs the checked icon with white
 * plus a 1px blue border, which is what gives the checked state its outlined look.
 *
 * Consumers must still pass `color='default'`; the palette remap alone only softens the
 * pink rather than removing it.
 */
const checkboxTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#77A7FF',
    },
    secondary: {
      main: '#E0E0E0',
    },
    background: {
      paper: 'white',
    },
  },
  overrides: {
    MuiCheckbox: {
      root: {
        '&$checked': {
          '& .MuiIconButton-label': {
            position: 'relative',
            '&:after': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              /* transparent = identical on light surfaces, correct in dark mode */
              backgroundColor: 'transparent',
              borderRadius: 2,
              border: '1px solid #77A7FF',
              zIndex: -1,
            },
          },
        },
      },
      checked: {},
    },
  },
});

export default checkboxTheme;
